{# src/Resources/app/administration/src/sw-admin-menu/sw-admin-menu.html.twig #}
{% block sw_admin_menu_header %}
{# <div class="sw-admin-menu__header"> #}
    <a :href="shopUrl" target="_blank" rel="noopener">
        {# <mt-icon
            class="sw-admin-menu__navigation-link-icon"
            name="regular-user"
            size="16px"
        />     #}
        {# <img
            v-if="!isExpanded"
            class="sw-admin-menu__header-logo-small"
            :src="shopLogo"
            :alt="$tc('sw-admin-menu.headerLogo')"
        >
        <img
            v-else
            class="sw-admin-menu__header-logo-big"
            :src="shopLogo"
            :alt="$tc('sw-admin-menu.headerLogo')"
        > #}
        {% parent %}
    </a>
{# </div> #}
{% endblock %}